import { configureStore } from "@reduxjs/toolkit";
import { doctorReducer } from "./doctor/slice";
import { calendarEventReducer as calendarEvents } from "./calendarEvent/slice";
import { appReducer as app } from "./app/slice";
import { currentUserReducer as currentUser } from "./currentUser/slice";
import { messageReducer as message } from "./message/slice";
import { twilioReducer as twilio } from "./twilio/slice";
import { membershipsDialogReducer as membershipsDialog } from "./membership_dialog/slice";

export const store = configureStore({
  reducer: {
    doctor: doctorReducer,
    calendarEvents,
    app,
    currentUser,
    message,
    twilio,
    membershipsDialog,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["twilioSlice/setTwilioClient", "messageSlice/setMessages"],
        ignoredPaths: ["twilio.client", "message.data"],
      },
    }),
});

export default store;
